module.exports = __webpack_public_path__ + "img/invert_colors_off.f4344446.svg";